module.exports = __webpack_public_path__ + "assets/closeMark-098930.svg";